import { RelacionDependenciaJefeComponent } from './relacion-dependencia-jefe.component';
import { RelacionDependenciaJefeRouting } from './relacion-dependencia-jefe-routing.module';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { RelacionJefeSedeComponent } from './relacion-jefe-sede.component';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}
@NgModule({
    declarations: [ RelacionDependenciaJefeComponent, 
                    RelacionJefeSedeComponent],
    imports: [
        RelacionDependenciaJefeRouting,
        SharedModule,
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        })
    ],
    entryComponents: []
})
export class RelacionDependenciaJefeModule { }
